module.exports = __webpack_public_path__ + "media/brands/suzuki-a4db5b13.png";